import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { SWAlertService } from '../../services/swalert.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { isNullOrUndefined } from 'util';
import { setDate } from 'ngx-bootstrap/chronos/utils/date-setters';
import * as _ from 'lodash';
@Component({
  selector: 'app-advancetoempreport',
  templateUrl: './advancetoempreport.component.html',
  styleUrls: ['./advancetoempreport.component.css']
})
export class AdvancetoempreportComponent implements OnInit {
  @ViewChild('datarow', { static: false }) private datarow: ElementRef;
  Dataraw: any;
  isOpenAll: boolean = false;
  showDetail: boolean = true;
  lstData: any = [];
  sndData: Array<any> = [];
  public settings = {};
  public settingsStatus = {};
  arrCompany: Array<any> = [];
  sReqCode: any = "";
  nvendor: any = "";
  svendor: any = "";
  nComcode = [];
  arrStatus = [];
  arrVendor: any = [];
  DataEmployee: any = [];
  DataVendor: any = [];
  ArrEmployee: any = [];
  arrRequest: any = [];
  nStatus: any = [];
  dReqDate: any;
  dDueDate: any;
  datarow_: any = [];
  arrDataExport: any = [];
  minDate: Date = new Date;
  maxDate: Date = new Date;

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-up";
  IcoSortAsc = "fas fa-sort-down";
  but = '<button type="button" class="btn btn-secondary btn-sm" (click)="GetData(row.sRequestCode,num)"><em class="fas fa-chevron-circle-down"></em></button>';
  Columns = [
    { ColumnName: "Status", SortField: "cClearComplete", Width: "6%" },
    { ColumnName: "Due date", SortField: "cClearComplete", Width: "8%" },
    { ColumnName: "Request Number Paid Advance", SortField: "sRequestCode", Width: "28%" },
    { ColumnName: "Amount", SortField: "nGrandTotalAmtInvoice", Width: "28%" },
    { ColumnName: "Description", SortField: "sInvoiceDesc", Width: "28%" },

  ]

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private System: TSFuntionService, private SW: SWAlertService, public datepipe: DatePipe, private router: Router) { }
  //AdvancetoempForm: FormGroup;
  //get _AdvancetoempForm() { return this.Advancetoemp.controls; }
  //get Advancetoemp() { return this._AdvancetoempForm.Advancetoemp as FormArray; }

  ngOnInit() {
    this.minDate.setDate(this.minDate.getDate() - 90);
    this.maxDate.setDate(this.maxDate.getDate());
    this.dDueDate = [this.minDate, this.maxDate];
    this.Status();
    // this.SetForm();
    this.loadCompany();
    this.loadVendor();
    this.setmultiselect();
    this.http.get<any>(this.System.SiteName + "api/Advancetoempreport/GetRequest").toPromise().then(res => {
      this.arrRequest = res;
    })
    const ua = this.System.GetUserStorage();
    if (ua) {
      this.nComcode = [];
      ua.lstCompCode.forEach(f =>
        this.nComcode.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
      );
    }

  }
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this.lstData = _.orderBy(this.lstData, [SortField], [this.SortDirection]);
    }
  }
  async loadCompany() {
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_COMPANY_CODE/*").toPromise().then(res => {
      const ua = this.System.GetUserStorage();
      if ([3, 4, 5].includes(ua.nRole)) {
        this.arrCompany = res.filter(f => f.cActive == 'Y').filter(f => f.cActive == 'Y' && f.COMPANY_CODE === ua.sCompCode);
      }
      else {
        this.arrCompany = res.filter(f => f.cActive == 'Y');
      }
    })
  }
  async loadVendor() {
    let sComcode: string = this.nComcode.length > 0 ? this.nComcode.map(e => e.COMPANY_CODE).join(",") : "";
    const vendor = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("nComcode", sComcode)
    };
    await this.http.get(this.System.SiteName + "api/Advancetoempreport/Getvendor", vendor).toPromise().then(data => {
      if (data) {
        this.DataVendor = data;
        this.arrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3 }))
      } else {
        this.arrVendor = [];
      }
    })
  }
  Status() {
    this.arrStatus = [{ nStatus: "N", sStatus: "Open" }, { nStatus: "Y", sStatus: "Cleared" }]
  }
  onVendorSelect(event) {
    if (this.svendor != "") {
      this.svendor = event.item.VENDOR_CODE;
      this.nvendor = event.item.VENDOR_CODE;
    } else {
      this.svendor = "";
      this.nvendor = "";

    }
  }
  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.Search();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.Search();
  }
  async Search() {
    let _this = this;
    let Result: any;
    _this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let sComcode: string = this.nComcode.length > 0 ? this.nComcode.map(e => e.COMPANY_CODE).join(",") : "";
    let nStatus: string = this.nStatus.length > 0 ? this.nStatus.map(e => e.nStatus).join(",") : "";
    let DataSearch = {
      sComcode: sComcode,
      sReqCode: this.sReqCode,
      vendor: this.nvendor,
      nStatus: nStatus,
      dReqDateFrom: _this.dReqDate != null ? _this.datepipe.transform(_this.dReqDate[0], 'yyyy-MM-dd') : "",
      dReqDateTo: _this.dReqDate != null ? _this.datepipe.transform(_this.dReqDate[1], 'yyyy-MM-dd') : "",
      dDueDateFrom: this.dDueDate != null ? _this.datepipe.transform(_this.dDueDate[0], 'yyyy-MM-dd') : "",
      dDueDateTo: this.dDueDate != null ? _this.datepipe.transform(_this.dDueDate[1], 'yyyy-MM-dd') : "",
    }
    this.OptionGrid.nCurrentPage = 1;
    let Json = JSON.stringify(DataSearch);
    await this.http.post(this.System.SiteName + "api/Advancetoempreport/Search", Json, { headers, responseType: 'json' }).toPromise().then(data => Result = data)
    if (Result) {
      this.Dataraw = Result;
      Result.forEach(async function (val, i) {
        let obj = {};
        let arrobj = await _this.GetDataReport(val.sRequestCode, null);
        obj = {
          Reqcode: val,
          DataClear: arrobj
        }
        _this.arrDataExport.push(obj);
      })
      this.OptionGrid.nTotalItem = Result.length;
      let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
      let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
      let nEndIndex_Take = nPageSize;
      this.lstData = [];
      //this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ cbSubDoc: val.sSupportDoc != null ? true : false }, val)));
      Result.forEach(val => this.lstData.push(Object.assign({}, val)));
      this.lstData = this.lstData.filter(f => f.cClearComplete).splice(nStartIndex_Take, nEndIndex_Take);
      let nStartItemPage = nStartIndex_Take + 1;
      let nLastItemPage = nStartIndex_Take + this.lstData.length;
      this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + Result.length + " Rows";
      if (this.nStatus.length > 0) {
        if (this.nStatus.length == 1) {
          if (this.nStatus[0].nStatus == "Y") {
            this.lstData = this.lstData.filter(f => f.reals == "Y");
          } else if (this.nStatus[0].nStatus == "N") {
            this.lstData = this.lstData.filter(f => f.reals == "N");
          }
        } if (this.nStatus.length == 2) {
          this.lstData = this.lstData.filter(f => f.reals != "O");
        }
      }
      if (this.lstData != null) {
        let num = this.lstData.length;
        for (let i = 0; i < num; i++) {
          this.datarow_[i] = false;
          this.sndData[i] = [];
        }
      } else {
        this.lstData = [];
      }
    } else {
      this.lstData = [];
    }

    setTimeout(() => {
      _this.System.UnBlockUI();
    }, 3000);
  }
  Clear() {
    this.minDate = new Date;
    this.maxDate = new Date;
    this.sReqCode = "";
    this.dReqDate = [];
    this.minDate.setDate(this.minDate.getDate() - 90);
    this.maxDate.setDate(this.maxDate.getDate());
    this.dDueDate = [this.minDate, this.maxDate];
    this.nStatus = [];
    this.nvendor = "";
    this.svendor = "";
    this.nComcode = [];
    this.lstData = [];
    const ua = this.System.GetUserStorage();
    if (ua) {
      ua.lstCompCode.forEach(f =>
        this.nComcode.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
      );
    }

  }

  async GetDataReport(ReqCode, row) {
    this.arrDataExport = [];
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let Result: Array<any> = [];
    let Data: any;
    let obj = { sReqCode: ReqCode }
    let Json = JSON.stringify(obj);
    await this.http.post(this.System.SiteName + "api/Advancetoempreport/GetDetail", Json, { headers, responseType: 'json' }).toPromise().then(data => Data = data)
    if (Data != null) {
      let ckData = this.Dataraw.filter(w => w.sRequestCode == ReqCode)[0];
      if (ckData != null) {
        let AmtInvoice = ckData.nGrandTotalAmtInvoice;
        let arrsum = Data.map(m => m.nGrandTotalAmtInvoice);
        let sumClear = arrsum.reduce((acc, cur) => acc + Number(cur), 0)
        let amtinvoices = isNullOrUndefined(AmtInvoice) == true ? 0 : AmtInvoice;
        let Outstanding = 0;
        if (ckData.cClearComplete != "Y") { Outstanding = amtinvoices - sumClear; }
        let addrow = {
          sRequestCode: "Outstanding",
          nGrandTotalAmtInvoice: Outstanding,
        }
        Data.forEach(val => Result.push(Object.assign({}, val)));
        Result.push(addrow);
        return Result;
      }
      //document.getElementById('datarows_' + row).innerHTML = "<tr *ngIf='datarow_[" + row + "] == true' id='datarow_{{" + row + "}}' #datarow style ='height:41.6px;' >" +
      //  "<td>fasf</td>" +
      //  "<td>fsaf</td>" +
      //  "<td>fsaf</td>" +
      //  "<td>fsaf</td>" +
      //  "<td>safsaf</td>";
    } else {
      let ckData = this.Dataraw.filter(w => w.sRequestCode == ReqCode)[0];
      if (ckData != null) {
        let addrow = {
          sRequestCode: "Outstanding",
          nGrandTotalAmtInvoice: ckData.nGrandTotalAmtInvoice,
        }
        Result.push(addrow);
        return Result;
      }
    }
    //else {
    //  let SetData = this.lstData.filter(f => f.sRequestCode == ReqCode)[0];
    //  if (SetData != null) {
    //    SetData.cClearComplete = "O";
    //  }
    //}
  }
  ExportExcel() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let Data = JSON.stringify(this.arrDataExport);
    this.http.post(this.System.SiteName + "api/Advancetoempreport/ExportExcel", Data, { headers, responseType: 'arraybuffer' }).subscribe(res => {
      var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      this.save(blob, "AdvanceReport.xlsx");
    })
  }
  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }
  async GetData(ReqCode, row) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let Result: Array<any> = [];
    let Data: any;
    let obj = { sReqCode: ReqCode }
    let Json = JSON.stringify(obj);
    await this.http.post(this.System.SiteName + "api/Advancetoempreport/GetDetail", Json, { headers, responseType: 'json' }).toPromise().then(data => Data = data)
    if (this.datarow_[row] == false) {
      this.datarow_[row] = true;
      if (Data != null) {
        let AmtInvoice = this.lstData.filter(w => w.sRequestCode == ReqCode)[0].nGrandTotalAmtInvoice;
        let arrsum = Data.map(m => m.nGrandTotalAmtInvoice);
        let sumClear = arrsum.reduce((acc, cur) => acc + Number(cur), 0)

        let Outstanding = 0;
        let ckData = this.Dataraw.filter(w => w.sRequestCode == ReqCode)[0];
        if (ckData != null) {
          if (ckData.cClearComplete != "Y") { Outstanding = AmtInvoice - sumClear; }
        }
       
       
        let addrow = {
          sRequestCode: "Outstanding",
          nGrandTotalAmtInvoice: Outstanding,
        }
        Data.forEach(val => Result.push(Object.assign({}, val)));
        Result.push(addrow);
        this.sndData[row] = Result;
        //document.getElementById('datarows_' + row).innerHTML = "<tr *ngIf='datarow_[" + row + "] == true' id='datarow_{{" + row + "}}' #datarow style ='height:41.6px;' >" +
        //  "<td>fasf</td>" +
        //  "<td>fsaf</td>" +
        //  "<td>fsaf</td>" +
        //  "<td>fsaf</td>" +
        //  "<td>safsaf</td>";
      } else {
        let ckData = this.Dataraw.filter(w => w.sRequestCode == ReqCode)[0];
        if (ckData != null) {
          let addrow = {
            sRequestCode: "Outstanding",
            nGrandTotalAmtInvoice: ckData.nGrandTotalAmtInvoice,
          }
          Result.push(addrow);
          this.sndData[row] = Result;
        }
      }
    } else {
      this.datarow_[row] = false;
    }

    //let printContents, popupWin;
    //printContents = this.datarow.nativeElement.innerHTML;

  }
  async Edit(sReqCode) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let obj = { sReqCode: sReqCode }
    let Json = JSON.stringify(obj);
    let Data: any;
    await this.http.post(this.System.SiteName + "api/Advancetoempreport/GetReqID/", Json, { headers, responseType: 'json' }).toPromise().then(data => Data = data)
    if (Data != null) {
      let ID = await this.System.Encrypt(Data[0].sRequestID);
      //  await this.router.navigate(["/approve"], { queryParams: { str: ID } });

      window.open(this.System.SiteName + 'approve?str=' + ID + '')
    }

  }
  OpenAll() {
    this.System.BlockUI();
    let _this = this;
    this.lstData.forEach(function (value, i) {
      _this.GetData(value.sRequestCode, i);
    })

    setTimeout(() => {
      this.isOpenAll = !this.isOpenAll;
      if (this.isOpenAll) {
        this.datarow_.forEach(function (val, o) {
          _this.datarow_[+o] = true;
        });

      } else {
        this.datarow_.forEach(function (val, o) {
          _this.datarow_[+o] = false;
        });

      }


      _this.System.UnBlockUI();
    }, 2000);
  }

  //SetForm() {
  //  this.AdvancetoempForm = this.formBuilder.group({
  //    sComCode: [""],
  //    sEmployee: [""],
  //    sReqCode: [""],
  //    sStatus: [""],
  //    Advancetoemp: new FormArray([
  //      new FormGroup({
  //        sComCode: new FormControl(''),
  //        nReqTypeID: new FormControl(''),
  //        nReqType: new FormControl(''),
  //      })
  //    ]),
  //  });
  //}
  setmultiselect() {
    this.settings = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settingsStatus = {
      singleSelection: false,
      idField: 'nStatus',
      textField: 'sStatus',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
}
